import {Component, input, output} from '@angular/core';
import {InvoiceStateId, InvoiceSummary} from '../../../../../api';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {BillingBadge} from '../../../../components/billing-badge/billing-badge';
import {InvoiceKindBadge} from '../../../../components/invoice-kind-badge/invoice-kind-badge';
import {ElciaButton} from '../../../../components/buttons/button/button';

@Component({
  selector: 'elcia-invoice-grid',
  imports: [TableModule, TranslatePipe, DatePipe, CurrencyPipe, BillingBadge, InvoiceKindBadge, ElciaButton],
  templateUrl: './invoice-grid.html',
  styleUrl: './invoice-grid.scss'
})
export class InvoiceGrid {
  invoices = input.required<InvoiceSummary[]>();
  showDirectDebitExport = input(false);
  invoiceSelected = output<InvoiceSummary>();
  creditRequested = output<InvoiceSummary>();
  deleteRequested = output<InvoiceSummary>();

  protected select(invoice: InvoiceSummary): void {
    if (invoice.stateName === InvoiceStateId.DRAFT) {
      this.invoiceSelected.emit(invoice);
    }
  }

  protected isDraft(invoice: InvoiceSummary): boolean {
    return invoice.stateName === InvoiceStateId.DRAFT;
  }

  // Only sent or paid invoices can be credited (matches the backend rule).
  protected canCredit(invoice: InvoiceSummary): boolean {
    return invoice.stateName === InvoiceStateId.SENT || invoice.stateName === InvoiceStateId.PAID;
  }

  protected credit(invoice: InvoiceSummary): void {
    this.creditRequested.emit(invoice);
  }

  // Only unnumbered drafts can be deleted (matches the backend rule).
  protected canDelete(invoice: InvoiceSummary): boolean {
    return invoice.stateName === InvoiceStateId.DRAFT && !invoice.number;
  }

  protected delete(event: Event, invoice: InvoiceSummary): void {
    event.stopPropagation();
    this.deleteRequested.emit(invoice);
  }
}
